module.exports = __webpack_public_path__ + "images/emoji/high_heel.734de6435706f5ed069b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/high_heel.png
// module id = 33eQ
// module chunks = 1